<div *ngIf="contests.length > 0 && !role" class="ion-text-center select-contest-container">
  <h1 class="select-contest-title">¡Hola! Aquí podrás registrar tus facturas</h1>
  <h2 class="select-contest-subtitle">Selecciona un concurso para continuar</h2>
  <p class="select-contest-advice">Las facturas ingresadas pueden participar en uno o varios concursos de acuerdo a los términos y condiciones.</p>

  <ion-grid>
    <ion-card class="alert-button" *ngIf="buttonsList">
      <ion-item lines="none" class="alert-item">
        <ion-icon name="alert-circle-outline" slot="start" class="alert-icon"></ion-icon>
        <ion-item lines="none" class="alert-item">
          <p class="alert-text-container">
            <span *ngIf="buttonsList.length > 1">¿Quieres unirte y disfrutar de los beneficios?</span>
            <span *ngIf="buttonsList.length === 1"> ¿Quieres unirte a <strong>{{ buttonsList[0].name }}</strong>?</span>
            <strong class="unete" (click)="openModalButtons(buttonsList)"> Únete aquí</strong>.
          </p>
        </ion-item>
      </ion-item>
    </ion-card>
    <ion-row class="ion-text-center">
      <ion-col *ngFor="let contest of contests" size="12" sizeMd="6">
        <ion-card
          (click)="selectContest(contest)"
          class="ion-activatable contest-card">
          <ion-ripple-effect></ion-ripple-effect>
          <ion-img class="contest-img" [src]="contest.image"></ion-img>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>

<div *ngIf="contests.length == 0 && !role" class="ion-text-center">
  <h1>En el momento no hay concursos</h1>
  <h2>Vuelve a visitarnos para poder seguir participando</h2>
</div>

<div class="ion-text-center" *ngIf="isPqrsActive">
  <h3>¿Quieres enviar una PQR?</h3>
  <ion-button (click)="goToPqrs()">Haz click aqui</ion-button>
</div>

